import { Modal, ModalOverlay, ModalContent } from '@chakra-ui/react';
import { ReactNode } from 'react';

export interface IBaseModal {
  isOpen: boolean;
  onClose?: () => void;
  children?: ReactNode;
  contentProps?: object;
  [x: string]: any;
}

export const BaseModal = ({ isOpen, onClose, children, contentProps, ...restProps }: IBaseModal) => (
  <Modal
    isOpen={isOpen}
    onClose={() => {
      if (onClose) {
        onClose();
      }
    }}
    closeOnOverlayClick={false}
    blockScrollOnMount={true}
    autoFocus={false}
    {...restProps}
  >
    <ModalOverlay />
    <ModalContent {...contentProps}>{children}</ModalContent>
  </Modal>
);
